<template>
  <div class="uni-max row m-0 calpage-d">
    <div class="col-lg-6 cd-padding">
      <div class="cal-results">
        <div class="p-4 uni-max-xs">
          <div class="cal-result-div">
            <div class="cal-subtitle">Total Payment</div>
            <div class="cal-redtitle mt-2">RM {{addComma(stotalAmount)}}</div>
          </div>
        </div>
        <div class="border-t p-4 uni-max-xs">
          <div class="cal-title">Breakdown</div>
          <div class="row m-0">
            <div class="pl-0 col-7">
              <div class="mb-3">Agreement Charges</div>
            </div>
            <div class="pr-0 col-5">
              <div class="font-weight-bold mb-3">RM {{addComma(sagreeCharge)}}</div>
            </div>
          </div>
          <div class="row m-0">
            <div class="pl-0 col-7">
              <div class="mb-3">Stamp Duty</div>
            </div>
            <div class="pr-0 col-5">
              <div class="font-weight-bold mb-3">RM {{addComma(sstampDuty)}}</div>
            </div>
          </div>
          <div class="row m-0">
            <div class="pl-0 col-7">
              <div>Total Additional Copy</div>
            </div>
            <div class="pr-0 col-5">
              <div class="font-weight-bold">RM {{addComma(stotaladdCopy)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-6 cd-padding">
      <div class="cal-form-container">
        <div class="cal-label">Monthly Rental Price</div> 
        <div class="filter-price-wrapper">
          <span class="filter-price-rm">RM</span>
          <input type='number' v-model="monthRent" class="filter-price-range">
        </div>

        <div class="cal-label">Tenancy Period</div> 
        <div class="filter-price-wrapper">
          <input type='number' v-model="tenanPeriod" class="filter-price-range">
          <span class="filter-price-rm w-auto ml-auto">years</span>
        </div>

        <div class="cal-label">Number of Additional Copies</div> 
        <div class="filter-price-wrapper">
          <input type='number' v-model="addCopy" class="filter-price-range">
          <span class="filter-price-rm w-auto ml-auto">copies</span>
        </div>

        <button @click="calculate" class="cal-btn">
          <span v-if="isloaded">Calculate</span>
          <div v-else class="spinner-border text-light" role="status" style="width: 1rem; height: 1rem;">
            <span class="sr-only">Loading...</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TenancyAgreement',
    data: function () {
      return {
        // Rental Calculator
        monthRent: null,
        tenanPeriod: null,
        addCopy: null,
        isloaded: true,

        // Results (update when press calculate)
        sagreeCharge: '',
        staxable: '',
        sstampDuty: '',
        stotaladdCopy: '',
        stotalAmount: '',
      }
    },
    mounted() {
      this.monthRent = 1200
      this.tenanPeriod = 3;
      this.addCopy = 1;

      this.sagreeCharge = this.agreeCharge;
      this.staxable = this.taxable;
      this.sstampDuty = this.stampDuty;
      this.stotaladdCopy = this.totaladdCopy;
      this.stotalAmount = this.totalAmount;
    },
    computed: {
      agreeCharge() {
        if (this.monthRent <= 10000) {
          return Math.round(this.monthRent * 0.25);
        } else {
          return Math.round(2500 + (this.monthRent - 10000) * 0.20);
        }
      },
      taxable() {
        var tax = 0;
        if (this.tenanPeriod == 1) {
          tax = Math.ceil(((this.monthRent * 12)) / 250) * 1
        } else if (this.tenanPeriod > 1 && this.tenanPeriod <= 3) {
          tax = Math.ceil(((this.monthRent * 12)) / 250) * 3
        } else if (this.tenanPeriod > 3 && this.tenanPeriod <= 5) {
          tax = Math.ceil(((this.monthRent * 12)) / 250) * 5
        } else if (this.tenanPeriod > 5) {
          tax = Math.ceil(((this.monthRent * 12)) / 250) * 7
        }
        if (tax < 0) { tax = 0 }
        return tax
      },
      stampDuty() { return this.isEven(parseFloat(this.taxable))},
      totaladdCopy() { return this.addCopy * 10 },
      totalAmount() { return Math.round(parseFloat(this.agreeCharge) + parseFloat(this.stampDuty) + parseFloat(this.totaladdCopy)) },
    },
    methods: {
      addComma: function (num) {
        if (num != null) {
          var num_parts = num.toString().split(".");
          num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return num_parts.join(".");
        } else {
          return '';
        }
      },
      isEven: function (n) {
        var num = n;
        if (Math.floor(n) % 2 == 0) { // is even with decimal
          num = Math.round(n)
          if (num % 2 != 0) {
            num = num + 1
          }
        } else { // is odd with decimal
          num = Math.floor(n) + 1;
        }
        return num;
      },
      calculate: function() {
        this.isloaded = false;

        setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
          this.isloaded = true;

          // Update Results
          this.sagreeCharge = this.agreeCharge;
          this.staxable = this.taxable;
          this.sstampDuty = this.stampDuty;
          this.stotaladdCopy = this.totaladdCopy;
          this.stotalAmount = this.totalAmount;
        }, 500);
      }
    },
  }
</script>